import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Checkbox, FormControlLabel, Typography,
} from '@mui/material';
import { Field, FieldLabel } from '../../UI';
import * as C from '../../../theme/colors.constants';

/**
 * Blocos "Adicionar Endereços +" e "Adicionar Telefones +".
 *
 * Aparecem idênticos nas abas Devedor e Cliente, por isso foram extraídos.
 * Equivalem a `UI/EnderecosV2` e `UI/TelefonesV2` do projeto real; os rótulos
 * seguem `helpers/constants/layout.constants.js` (`EnderecoConst`,
 * `TelefoneConst`).
 */

export function LinkAdicionar({ children }) {
  return (
    <Typography
      role="button"
      tabIndex={0}
      sx={{
        color: C.navy,
        fontWeight: 700,
        cursor: 'pointer',
        mt: 2,
        mb: 1,
        fontSize: 'clamp(13px, 0.78vw, 18px)',
        '&:hover': { textDecoration: 'underline' },
      }}
    >
      {children}
    </Typography>
  );
}
LinkAdicionar.propTypes = { children: PropTypes.node };
LinkAdicionar.defaultProps = { children: null };

export function BlocoEnderecos() {
  return (
    <>
      <LinkAdicionar>Adicionar Endereços +</LinkAdicionar>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr) minmax(0, 1fr)', md: 'repeat(4, minmax(0, 1fr))' },
          gap: 'clamp(10px, 0.8vw, 22px)',
        }}
      >
        <Field label="CEP:" />
        <Field label="Endereço:" />
        <Field label="Número:" />
        <Field label="Complemento:" />
        <Field label="Bairro:" />
        <Field label="Cidade:" />
        <Field label="Estado:" tipo="select" options={['SP', 'RJ', 'MG', 'PR', 'RS', 'SC', 'BA', 'GO', 'ES']} />
      </Box>
    </>
  );
}

export function BlocoTelefones() {
  return (
    <>
      <LinkAdicionar>Adicionar Telefones +</LinkAdicionar>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'minmax(0, 1fr) minmax(0, 1fr)', md: 'minmax(0, 1.2fr) minmax(0, 0.5fr) minmax(0, 1fr) minmax(0, 1.2fr) minmax(0, 0.8fr)' },
          gap: 'clamp(10px, 0.8vw, 22px)',
          alignItems: 'end',
        }}
      >
        <Field label="Tipo de telefone:" tipo="select" options={['Comercial', 'Residencial', 'Celular', 'Serviço']} />
        <Field label="DDD:" value="16" />
        <Field label="Telefone:" value="38777100" />
        <Field label="Observação:" />
        <Box>
          <FieldLabel>&nbsp;</FieldLabel>
          <FormControlLabel
            control={<Checkbox size="small" defaultChecked />}
            label={<Typography variant="body2">Principal</Typography>}
            sx={{ display: 'block', ml: 0 }}
          />
          <FormControlLabel
            control={<Checkbox size="small" defaultChecked />}
            label={<Typography variant="body2">WhatsApp</Typography>}
            sx={{ display: 'block', ml: 0 }}
          />
        </Box>
      </Box>
    </>
  );
}
